import Logger from '../lib/logger';
import { getCardData, handlize } from '../lib/util.functions';
import VariantUpdater from './VariantUpdater';

class BundlerState extends HTMLElement {
  #NAME = 'BundlerState'
  #bundle
  #searchParams
  #editParam
  #indexParam

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.dataset.inIframe = window.location !== window.parent.location;
    //
    this.stepTracker = this.querySelector('.bundler-header__step-tracker');
    let stepEl = this.stepTracker.firstElementChild;
    this.sidecart = this.querySelector('bundler-side-cart');
    const sidecartBody = this.sidecart.querySelector('[data-body]');
    let sidecartContainer = this.sidecart.querySelector('[data-item-container-type]');
    this.stepContainers = Array.from(this.querySelectorAll('bundler-step'));
    this.stepContainers.forEach((el,i) => el.dataset.bundlerStep = i + 1);
    const labels = [];
    const sidecartContainers = this.stepContainers.map(el => ({ 
      label: el.dataset.label, 
      usePlaceholder: el.dataset.usePlaceholder, 
      placeholderLabel: el.dataset.placeholderLabel,
      icon: el.dataset.icon,
      custom: el.dataset.custom,
    }))
      .map(dta => {
        labels.push(dta.label);
        this.#addTrackerStep(dta, stepEl);
        return this.#createSideCartContainer(dta, sidecartContainer);
      });
    sidecartBody.append(...sidecartContainers);
    sidecartContainer.remove();
    sidecartContainer = null;
    this.stepDependantEls = this.querySelectorAll('[data-step]');
    this.continueBtns = this.querySelectorAll('[data-continue-btn]');
    this.backBtns = this.querySelectorAll('[data-back-btn]');
    this.#bundle = this.querySelector('custom-bundle');
    this.#bundle.dataset.labels = labels;
    this.#searchParams = new URLSearchParams(window.location.search);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    //
    this.#editParam = this.#searchParams.get('edit');
    this.#indexParam = this.#searchParams.get('groupindex');
    /* if (this.#editParam) alert(`edit id: ${this.#editParam}, index: ${this.#indexParam}`); */
    //
    this.continueBtns.forEach(btn => {
      btn.addEventListener('click', () => this.#onNav());
    });
    //
    this.backBtns.forEach(btn => {
      btn.addEventListener('click', () => this.#onNav(true));
    });
    //
    window.addEventListener('popstate', (e) => {
      this.#bundle.save(e.state);
      this.#onStateChange(e.state)
    });
    //
    this.addEventListener('bundlestate:update', (e) => this.#updateState(e.detail.replace || false));
  }

  #updateState(replace = false) {
    Logger.info(`${this.#NAME} > #updateState > replace`, replace);
    const state = this.#bundle.data;
    console.log(state);
    //
    if (replace) {
      history.replaceState(state, '',`${window.location.pathname}?step=${state.currentStep}`);
    } else {
      history.pushState(state, '', `${window.location.pathname}?step=${state.currentStep}`);
    }
    //
    this.#onStateChange(state);
  }

  #onStateChange(state) {
    Logger.info(`${this.#NAME} > #onStateChange`, state);
    this.stepContainers.forEach(el => {
      el.dataset.show = false;
      if (el.dataset.bundlerStep == state.currentStep) {
        this.#updateCards(el, state);
        el.dataset.show = true;
      }
      el.querySelectorAll('.bundler-grid__items__container').forEach(ic => {
        const totalItems = Array.from(ic.querySelectorAll('product-card'))
          .map(pc => parseInt(pc.dataset.quantity))
          .reduce((a,b) => a + b, 0);
        ic.querySelector('.bundler-grid__items__grid').dataset.totalItems = totalItems;
      })
    });
    //
    state = this.#checkStepComplete(state);
    //
    this.stepDependantEls.forEach(el => el.dataset.step = state.currentStep);
    //
    this.continueBtns.forEach(btn => {
      btn.dataset.disabled = !(state.completedSteps >= state.currentStep);
    });
    //
    this.#setOnlyForDivVisibility(state);
    //
    this.sidecart?.update(state, this.#bundle.getNumItems(), this.#bundle.getTotal());
    //
   /*  this.#setOnlyForDivVisibility(); */
    //
    if (this.#editParam) {
      this.sidecart.querySelector(`[data-variant-id="${this.#editParam}"][data-step="${state.currentStep}"][data-group-index="${this.#indexParam}"] button[data-icon="edit"]`)?.click();
      this.#editParam = undefined;
      this.#indexParam = undefined;
    }
    //
    if (this.dataset.show !== 'true') this.dataset.show = 'true';
  }

  #onNav(back = false) {
    if (this.dataset.inIframe === 'true') return;
    this.#searchParams = new URLSearchParams(window.location.search);
    let step = parseInt(this.#searchParams.get('step'));
    step += (back ? -1 : 1);
    //
    if (step === this.stepTracker.childElementCount) {
      window.location.href = `/pages/bundle-review?bundle=${this.#bundle.id}`;
    } else {
      this.#bundle.currentStep = step;
      this.#updateState();
      window.scrollTo({top: 0, behavior: 'instant'});
    }
  }

  #updateCards(stepContainer, state) {
    Logger.info(`${this.#NAME} > #updateCards`, state);
    const cards = Array.from(stepContainer.querySelectorAll(`product-card`));
    /* console.log(cards); */
    let productId, ids;
    let index;
    let multiple;
    let warrantyEls, warrantyProdId, warrantyProdCard;
    // update all cards in current step
    cards.forEach(card => {
      productId = null;
      ids = state.addedComponentProductIds.map((id, i) => [id,i]).filter(arr => arr[0] === card.dataset.productId );
      if (ids.length) {
        ids.forEach(arr => {
          if (state.addedComponentSteps[arr[1]] === state.currentStep && state.addedComponentGroupIndex[arr[1]] == card.dataset.groupIndex) {
            productId = arr[0];
            index = arr[1];
          }
        })
      }
      /* console.log(productId, card.dataset.productTitle); */
      warrantyEls = [card.querySelector('extended-warranty'), card.template?.content.querySelector('extended-warranty')].filter(e => e);
      //
      warrantyEls.forEach(warrantEl => {
        warrantyProdId = warrantEl.dataset.warrantyProductId;
        warrantyProdCard = cards.find(c => c.dataset.productId === warrantyProdId);
        //
        if (warrantyProdCard) {
          warrantEl.dataset.productPrice = warrantyProdCard.dataset.regularPrice;
          warrantEl.dataset.productQuantity = warrantyProdCard.dataset.quantity;
        }
      })

      if (productId) {
        multiple = card.dataset.selectMultiple === 'true';
        //
        if (warrantyEls.length) {
          warrantyEls[0].dataset.variantId = state.addedComponentReference[index];
          warrantyEls[0].dataset.optionSelected = state.addedComponentOptions[index];
          warrantyEls[0].dataset.totalPrice = state.addedComponentPrices[index];
        }
        //
        if (multiple) {
          this.#updateCard(card, {
            variantId: state.addedComponentReference[index], 
            quantity: this.#updateVariantUpdaters(state, card, productId),
            step: state.addedComponentSteps[index]
          });
        } else {
          this.#updateCard(card, {
            variantId: state.addedComponentReference[index], 
            quantity: state.addedComponentQuantities[index],
            price: state.addedComponentPrices[index],
            options: state.addedComponentOptions[index],
            image: state.addedComponentImages[index] !== '' ? state.addedComponentImages[index] : undefined,
            step: state.addedComponentSteps[index]
          });
        }
       
      } else {
        this.#updateCard(card, { quantity: 0 });
      }
    })
  }

  #updateCard(card, { variantId, quantity, price, options, image, step }) {
    /* Logger.info(`${this.#NAME} > #updateCard`, card, { variantId, quantity, price, options, image, step }); */
    if (variantId) card.dataset.variantId = variantId;
    if (quantity !== undefined) card.dataset.quantity = quantity;
    if (price) card.dataset.productPrice = price;
    if (options) card.dataset.options = options;
    if (image) card.dataset.productImage = image;
    if (step) card.dataset.step = step;
  }

  #updateVariantUpdaters(state, card, productId) {
    let quant = 0, variantId, vu;
    const indexes = state.addedComponentProductIds.map((val, i) => val === productId ? i : null).filter(a => a);
    const updaters = Array.from(card.querySelectorAll('variant-updater'));
    //
    indexes.forEach(index => {
      variantId = state.addedComponentReference[index];
      vu = updaters.find(el => el.dataset.variantId === variantId && index == el.dataset.bundlerIndex);
      quant += state.addedComponentQuantities[index];
      /* console.log(index, state.addedComponentQuantities[index]); */
      //
      if (vu) {
        vu.dataset.quantity = state.addedComponentQuantities[index];
      } else {
        vu = new VariantUpdater({ 
          variantId, 
          quantity: state.addedComponentQuantities[index], 
          image: state.addedComponentImages[index] !== '' ? state.addedComponentImages[index] : undefined, 
          options: state.addedComponentOptions[index],
          customText: state.addedComponentCustomText[index],
          bundleIndex: index,
          groupIndex: state.addedComponentGroupIndex[index]
        });
        card.content?.appendChild(vu);
      }
      //
      updaters.forEach((updater) => {
        let variantId = state.addedComponentReference?.find((r, i) => r === updater.dataset.variantId && i == updater.dataset.bundlerIndex);
        if (!variantId) updater.remove();
      });
    });
    //
    return quant;
  }

  serializeForm(form) {
    const formData = Array.from(form.elements).reduce((acc, element) => {
        if (element.name) {
            acc[element.name] = {
                value: element.value,
                validity: element.validity,
                valid: element.checkValidity()
            };
        }
        return acc;
    }, {});

    return formData;
  }

  #checkStepComplete(state) {
    let form = this.stepContainers[state.currentStep - 1]?.form;
    const valid = form.checkValidity();
    
    const serializedData = this.serializeForm(form);
    console.log('kj serializedData', serializedData);
    console.log('kj form.checkValiditiy()', valid);
    
    this.#bundle.completedSteps = valid ? state.currentStep : state.currentStep - 1;
    const updatedState = this.#bundle.data;
    if(JSON.stringify(updatedState) !== JSON.stringify(state)) {
      history.replaceState(updatedState, '',`${window.location.pathname}?step=${state.currentStep}`);
    }
    return updatedState;
  }

  #setOnlyForDivVisibility(state) {
    /* const state = this.#bundle.data; */
    console.log(state);
    /* return; */
    let productId, forCard, title, selectedCards;
    this.stepContainers[state.currentStep - 1].querySelectorAll('[data-only-for-product]').forEach(el => {
      productId = el.dataset.onlyForProduct;
      forCard = this.stepContainers[state.currentStep - 1].querySelector(`product-card[data-product-id="${productId}"]:has(input:checked)`);
      el.dataset.forProductSelected = !!forCard;
      /* console.log(el, el.dataset.forProductSelected, forCard); */
      // add any included products when forProduct is is selected
      if (el.dataset.forProductSelected === 'true') {
        el.querySelectorAll(`product-card:has(input[type="radio"])`).forEach(c => {
          c.productBtnInput.required = true;
          c.productBtnInput.disabled = false;
        });
        //
        el.querySelectorAll('product-card[data-included="true"]:has(input[type="radio"])').forEach(card => {
          const quantity = card.dataset.oneForEvery ? Math.ceil(parseInt(forCard.dataset.quantity) / parseInt(card.dataset.oneForEvery)) : 1;
          const data = getCardData(card, 'add', { quantity }).data;
          if (state.addedComponentReference.includes(data.variantId)) {
            if (card.dataset.quantity != quantity) {
              this.#bundle.updateAccessory(data);
              this.#updateState(true)
            }
          } else if (card.dataset.solo === 'true') {
            this.#bundle.addAccessory(data);
            this.#updateState(true);
          }
        });
        
        // KJ Dec 6 2024 - Previously only the above block existed which targets data-included=true
        el.querySelectorAll('product-card[data-included="false"]:has(input[type="radio"])').forEach(card => {
          const quantity = card.dataset.oneForEvery ? Math.ceil(parseInt(forCard.dataset.quantity) / parseInt(card.dataset.oneForEvery)) : 1;
          console.log('kj in data-included-false radio type - quantity', quantity, card.dataset.oneForEvery, card);
          const data = getCardData(card, 'add', { quantity }).data;
          if (state.addedComponentReference.includes(data.variantId)) {
            if (card.dataset.quantity != quantity) {
              this.#bundle.updateAccessory(data);
              this.#updateState(true)
            }
          } else if (card.dataset.solo === 'true') {
            this.#bundle.addAccessory(data);
            this.#updateState(true);
          }
        });
        //
        el.querySelectorAll('product-card[data-one-for-every][data-included="true"]:has(input[type="checkbox"])').forEach(card => {
          const quantity = Math.ceil(parseInt(forCard.dataset.quantity) / parseInt(card.dataset.oneForEvery));
          card.dataset.numAllowed = quantity;
          card.dataset.minQuantity = quantity
          card.template.dataset.numAllowed = quantity;
          card.template?.content.querySelectorAll('[data-num-allowed]').forEach(el => { 
            el.dataset.minQuantity = quantity - parseInt(card.dataset.quantity); 
            el.dataset.numAllowed = quantity - parseInt(card.dataset.quantity);
          });
        });
        //
        el.querySelectorAll('product-card[data-one-for-every]:not([data-included="true"]):has(input[type="radio"])').forEach(card => {
          const quantity = Math.ceil(parseInt(forCard.dataset.quantity) / parseInt(card.dataset.oneForEvery));
          card.dataset.numAllowed = quantity;
          // Not sure what this is supposed to do but it's causing the Continue button to be disabled
          // when it shouldn't be (Issue #6). The form validation already will require that one of
          // the items in the accessory group is selected without this.
          // card.dataset.minQuantity = quantity
          card.template.dataset.numAllowed = quantity;
          card.template?.content.querySelectorAll('[data-num-allowed]').forEach(el => { 
            // el.dataset.minQuantity = quantity - parseInt(card.dataset.quantity); 
            el.dataset.numAllowed = quantity - parseInt(card.dataset.quantity);
          });
          //
          if (card.dataset.solo === 'true' && !card.dataset.selectMultiple === 'true') {
            const data = getCardData(card, 'add', { quantity }).data;
            if (state.addedComponentReference.includes(data.variantId)) {
              /* this.#bundle.updateAccessory(data); */
              if (card.dataset.quantity != quantity) {
                this.#bundle.updateAccessory(data);
                this.#updateState(true)
              }
            } else {
              this.#bundle.addAccessory(data);
              this.#updateState(true);
            }
          }
        });
      }
      /* return */
      // remove any selected products within when forProduct is not selected
      if (el.dataset.forProductSelected === 'false') {
        el.querySelectorAll(`product-card:has(input[type="radio"])`).forEach(c => {
          c.productBtnInput.required = false;
          c.productBtnInput.disabled = true;
        });
        selectedCards = el.querySelectorAll(`product-card:has(input:checked)`);
        if (selectedCards.length) {
          selectedCards.forEach(c => {
            if(c.dataset.connected === 'true') {
              title = handlize(c.dataset.productTitle);
              console.log(title, c.dataset.step, c.dataset.onlyForProductId, this.sidecart.querySelectorAll(`[data-connected="true"][data-title="${title}"][data-step="${c.dataset.step}"][data-group-index="${c.dataset.groupIndex}"][data-only-for-product-id="${c.dataset.onlyForProductId}"]`));
              this.sidecart.querySelectorAll(`[data-connected="true"][data-title="${title}"][data-step="${c.dataset.step}"][data-group-index="${c.dataset.groupIndex}"][data-only-for-product-id="${c.dataset.onlyForProductId}"]`).forEach(item => {
                this.#bundle.updateAccessory({ variantId: item.dataset.variantId, groupIndex: parseInt(item.dataset.groupIndex), quantity: 0 });
                this.#updateState(true);
              })
            } else {
              console.log(c.dataset.productTitle, c.dataset.groupIndex)
              this.#bundle.updateAccessory({ variantId: c.dataset.variantId, groupIndex: parseInt(c.dataset.groupIndex), quantity: 0 });
              this.#updateState(true);
            }
          });
        }
      }
    });
  }

  #createSideCartContainer(dta, sidecartContainer) {
    const el = sidecartContainer.cloneNode(true);
    el.dataset.itemContainerType = dta.label;
    const title = el.querySelector('side-cart-container-title');
    title.textContent = dta.label;
    if (dta.usePlaceholder == 'true') {
      const span = el.querySelector('.bundler-side-cart__item-container__placeholder span');
      span.textContent = dta.placeholderLabel;
    } else {
      let row = el.querySelector('[data-row="1"]');
      row.remove();
      row = null;
    }
    return el;
  }

  #addTrackerStep(dta, stepEl) {
    const el = stepEl.cloneNode(true);
    el.dataset.label = dta.label;
    el.dataset.icon = dta.icon;
    if (dta.custom) el.setAttribute('style', `--custom-icon-url: url(${dta.custom})`);
    this.stepTracker.insertBefore(el, stepEl);
  }

}

customElements.define('bundler-state', BundlerState);
